import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    lineHeight: "1.7",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    width: "100%",
    lineHeight: "1.7",
  },
  portraitTopSection: {
    flexDirection: "row",
    height: "50%",
  },
  landscapeTopSection: {
    flexDirection: "row",
    width: "50%",
    height: "100%",
  },
  portraitBottomSection: {
    flexDirection: "row",
    height: "50%",
    width: "100%",
  },
  arrowIconCont: {
    fontSize: "6px",
    width: "40px",
    color: "#FF0000",
    marginTop: "-8px",
  },
  arrowIconCont2: {
    fontSize: "6px",
    color: "#FF0000",
    width: "32px",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "18px",
    height: "15px",
  },
  portraitArabTopSection1: {
    margin: "0 6px",
  },
  portraitEngTopSection2: {
    width: "60%,",
    transform: "rotate(90deg)",
    height: "120%",
    marginLeft: "50px",
    marginTop: "-45px",
  },
  landscapeEngTopSection3: {
    marginLeft: "30px",
    height: "130%",
    width: "57%,",
    transform: "rotate(90deg)",
    marginTop: "-50px",
  },
  landscapeArabTopSection3: {
    height: "100%",
    width: "80%,",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
  pointingText: {
    marginBottom: "6px",
    marginTop: "-13px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
});

const MyDocument8 = ({ arabChunks, engChunks }) => {
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  let landscapePagesArray = [];
  const landscapePages = () => {
    let a = 2,
      e = 5;
    for (let i = 1; i < 4; i++) {
      landscapePagesArray.push(
        <>
          <View
            style={{
              textAlign: "right",
              width: "100%",
              height: "50%",
              flexDirection: "row",
            }}
          >
            <View style={Styles.landscapeTopSection}>
              <View style={Styles.arrowIconCont}></View>
              <View style={[Styles.landscapeEngTopSection3]}>
                {arabicText(arabChunks[a])}
              </View>
              <View style={[Styles.arrowIconCont, { marginLeft: "45px" }]}>
                <View style={{ position: "absolute", top: "90%" }}>
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={Styles.arrowIcon}
                  ></Image>
                </View>
              </View>
            </View>

            <View style={Styles.landscapeTopSection}>
              <View style={Styles.arrowIconCont}></View>
              <View style={[Styles.landscapeEngTopSection3]}>
                {arabicText(arabChunks[a - 1])}
              </View>
              <View style={[Styles.arrowIconCont, { marginLeft: "45px" }]}>
                <View style={{ position: "absolute", top: "86%" }}>
                  <Image
                    src="/images/leftcurvepdf_arrow.png"
                    style={[Styles.curveArrowIcon, { width: "14px" }]}
                  ></Image>
                </View>
              </View>
            </View>
          </View>

          <View
            style={{
              textAlign: "left",
              height: "42%",
              width: "100%",
              flexDirection: "row",
              marginTop: "30px",
            }}
          >
            <View style={[Styles.landscapeTopSection, { width: "45%" }]}>
              <View style={[Styles.arrowIconCont, { alignItems: "flex-end" }]}>
                <View style={{ marginTop: "4px" }}>
                  <Image
                    src="/images/rightcurvepdf_arrow.png"
                    style={Styles.curveArrowIcon}
                  ></Image>
                </View>
              </View>
              <View style={Styles.portraitArabTopSection1}>
                {engChunks[e]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
            </View>
            <View style={{ width: "50px" }}></View>
            <View style={[Styles.landscapeTopSection, { width: "45%" }]}>
              <View style={[Styles.arrowIconCont, { alignItems: "flex-end" }]}>
                <View style={{ marginTop: "10px" }}>
                  <Image
                    src="/images/rightpdf_arrow.png"
                    style={Styles.arrowIcon}
                  ></Image>
                </View>
              </View>
              <View style={Styles.portraitArabTopSection1}>
                {engChunks[e + 1]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
            </View>
          </View>
        </>
      );
      a += 2;
      e -= 2;
    }
  };
  landscapePages();

  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View style={Styles.portraitTopSection}>
          <View style={Styles.arrowIconCont2}></View>
          <View style={[Styles.portraitEngTopSection2]}>
            {arabicText(arabChunks[0])}
          </View>
          <View style={[Styles.arrowIconCont2, { marginLeft: "45px" }]}>
            <View style={{ position: "absolute", top: "87%" }}>
              <Text style={Styles.pointingText}>بداية النص</Text>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View style={Styles.portraitBottomSection}>
          <View style={Styles.arrowIconCont}></View>
          <View style={Styles.portraitArabTopSection1}>
            {engChunks[7]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
          <View style={[Styles.arrowIconCont]}>
            <View style={{ width: "40px", position: "absolute", top: "100%" }}>
              <Text style={[Styles.pointingText]}>End of Text</Text>
              <Image
                src="/images/leftpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-start" }]}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      {landscapePagesArray.map((array, index) => {
        return (
          <Page
            size="A4"
            style={Styles.landscapePage}
            orientation="landscape"
            key={index}
          >
            {array}
          </Page>
        );
      })}

      <Page size="A5" style={[Styles.portraitPage]}>
        <View style={Styles.portraitTopSection}>
          <View style={[Styles.arrowIconCont]}>
            <View style={{ position: "absolute", top: "88%", right: "6px" }}>
              <Text style={Styles.pointingText}>نهاية النص</Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View
            style={[
              Styles.portraitEngTopSection2,
              {
                marginRight: "88px",
              },
            ]}
          >
            {arabicText(arabChunks[7])}
          </View>
        </View>
        <View style={Styles.portraitBottomSection}>
          <View style={[Styles.arrowIconCont2]}>
            <Text style={[Styles.pointingText, { width: "40px" }]}>
              Start of text
            </Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
          <View style={Styles.portraitArabTopSection1}>
            {engChunks[0]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
          <View
            style={[Styles.arrowIconCont2, { marginRight: "-45px" }]}
          ></View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument8;
